export const colors = {
	white: '#FFFFFF',
	black: '#000000',
	gray: '#CCCCCC',
	tintLight: '#2F95dC',
	tintDark: '#FFFFFF',
	link: '#2E78B7',
	background: '#F5F4ED',
	background100: '#FFF7F2',
	background200: '#E8E7E1',
	background300: '#DBDAD3',
	background400: '#D9D8D2',
	primary: '#2A3243',
	primary100: '#EDF7F7',
	primary200: '#D4ECED',
	primary500: '#5C6E93',
	primary700: '#34787A',
	primaryDisabled: '#D5D9E3',
	primarySemiTransparent: 'rgba(42, 50, 67, 0.5)',
	secondary: '#4F9CAB',
	secondaryDisabled: '#98A8AB',
	accent: '#EA5153',
	accentDisabled: '#EA515380',
	danger100: '#FCE8E9',
	danger800: '#E52527',
	hint: '#5C6E93',
	neutral200: '#FAFAFA',
	neutral300: '#F1F1EF',
	neutral400: '#E5E4E1',
	neutral: '#E0E3EB',
	black200: '#E0E3EB',
	black400: '#9BA7C0',
	black500: '#5C6E93',
	black600: '#495774',
	black700: '#2A3243',
	black800: '#0C0E13',
	transparent: 'transparent',
	toast: {
		success: '#51A461',
		warning: '#DEC30C',
		error: '#FF583E',
		info: '#179BED',
	},
	info100: '#EFF6FF',
	info700: '#2253D5',
} as const;

export default {
	light: {
		text: colors.black,
		background: colors.white,
		tint: colors.tintLight,
		tabIconDefault: colors.gray,
		tabIconSelected: colors.tintLight,
	},
	dark: {
		text: colors.white,
		background: colors.black,
		tint: colors.tintDark,
		tabIconDefault: colors.gray,
		tabIconSelected: colors.tintDark,
	},
};
